import { render, staticRenderFns } from "./navItems.vue?vue&type=template&id=44e1b2b0&scoped=true"
import script from "./navItems.vue?vue&type=script&lang=js"
export * from "./navItems.vue?vue&type=script&lang=js"
import style0 from "./navItems.vue?vue&type=style&index=0&id=44e1b2b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e1b2b0",
  null
  
)

export default component.exports